import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { InteractionStatus } from '@azure/msal-browser';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { FullPageSpinner } from '../components/ui/Spinner';

export const SIGN_IN_PATH = '/signin';

/** Route guard: unauthenticated visitors go to /signin with the deep link preserved in ?returnTo. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();
  const location = useLocation();

  if (isAuthenticated) return <>{children}</>;
  if (inProgress !== InteractionStatus.None) return <FullPageSpinner label="Signing in" />;

  const returnTo = `${location.pathname}${location.search}${location.hash}`;
  const params = new URLSearchParams({ returnTo });
  return <Navigate to={`${SIGN_IN_PATH}?${params.toString()}`} replace />;
}
